import { Component, Input, } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { switchMap } from 'rxjs/operators';
import { Order } from '../../models/order';
import { CourierRepo } from '../../repositories/courier.repo';
import { OrderService } from '../../services/order.service';

@Component({
  templateUrl: './passed-order-preview.component.html',
  styleUrls: ['./passed-order-preview.component.scss'],
})
export class PassedOrderPreviewComponent {
  @Input({ required: true }) data!: Order;

  constructor(
    private courierRepo: CourierRepo,
    private modalController: ModalController,
    private orderService: OrderService,
  ) { }

  decline(): void {
    this.courierRepo.declinePushedOrder(this.data.id)
      .subscribe(async () => {
        const topModal = await this.modalController.getTop();
        if (topModal) {
          await this.modalController.dismiss();
        }
      })
  }

  accept(): void {
    this.courierRepo.acceptPushedOrder(this.data.id)
      .pipe(
        switchMap(() => this.orderService.refreshOrders()),
      )
      .subscribe(async () => {
        const topModal = await this.modalController.getTop();
        if (topModal) {
          await this.modalController.dismiss();
        }
      })
  }
}
